import { X } from "lucide-react";

export const Modal = ({ title, onClose, children, wide = false }) => (
  <div
    className="fixed inset-0 z-[120] bg-anthracite/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-6"
    data-admin-ui="true"
    data-testid="edit-modal"
    onClick={onClose}
  >
    <div
      className={`bg-ivory text-anthracite w-full ${wide ? "max-w-4xl" : "max-w-xl"} max-h-[92svh] overflow-y-auto shadow-2xl`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-6 py-4 border-b border-sand sticky top-0 bg-ivory z-10">
        <p className="font-serif text-xl" data-testid="edit-modal-title">{title}</p>
        <button onClick={onClose} aria-label="Chiudi" data-testid="edit-modal-close" className="p-1 hover:text-bordeaux">
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="px-6 py-6">{children}</div>
    </div>
  </div>
);

export const Label = ({ children }) => (
  <span className="block text-[11px] uppercase tracking-[0.2em] text-anthracite/60 mb-2">{children}</span>
);

export const inputCls =
  "w-full bg-white border border-sand px-3 py-2.5 text-sm outline-none focus:border-bordeaux transition-colors";

export const TextArea = ({ label, value, onChange, rows = 3, testId }) => (
  <label className="block">
    <Label>{label}</Label>
    <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={rows} className={inputCls} data-testid={testId} />
  </label>
);

export const Input = ({ label, value, onChange, testId, ...rest }) => (
  <label className="block">
    <Label>{label}</Label>
    <input value={value} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testId} {...rest} />
  </label>
);

export const SaveBar = ({ onSave, onCancel, saving, saveLabel = "Salva" }) => (
  <div className="mt-6 flex items-center justify-end gap-3">
    <button onClick={onCancel} className="btn-outline !px-5 !py-2.5 !text-xs" data-testid="edit-cancel">
      Annulla
    </button>
    <button onClick={onSave} disabled={saving} className="btn-primary !px-5 !py-2.5 !text-xs" data-testid="edit-save">
      {saving ? "Salvataggio…" : saveLabel}
    </button>
  </div>
);
